import { Injectable } from '@angular/core';
import { WorkflowInitializeService } from '../service/workflow-initialize/workflow-initialize.service';
import { WorkflowService } from '../service/workflow/workflow.service';
import { WidgetContextData, WorkflowContextData } from '../widget-context.type';
import { WidgetContextDataShared } from './widget-context-data.shared';
import { WidgetStateService } from './widget-state.service';
import { PageInstance } from '@workflow/class/page.service';
import { FlowInstance } from '@workflow/class/flow.service';

@Injectable({
  providedIn: 'root'
})
export class WorkflowWidgetService {
  constructor(
    private readonly workflowService: WorkflowService,
    private readonly workflowInitializeService: WorkflowInitializeService,
    private readonly widgetStateService: WidgetStateService
  ) {}

  public init(): Promise<{ currentFlow: FlowInstance; currentPage: PageInstance }> {
    // this.widgetLoggerService.logMessage('Widget Contextual Data ->', WidgetContextDataShared.widgetContext);
    if (!this.isConfigValid(WidgetContextDataShared.widgetContext)) {
      return;
    }

    this.widgetStateService.updateState('loading');

    return new Promise<{ currentFlow: FlowInstance; currentPage: PageInstance }>((resolve) => {
      const config = WidgetContextDataShared.widgetContext.config;
      this.workflowInitializeService.initBackend().then(() => {
        this.widgetStateService.updateState('', 'Backend Loaded.');
        this.initiateFlow(config);

        const currentFlow = this.workflowService.currentFlow;
        const currentPage = this.workflowService.currentPage;

        resolve({ currentFlow, currentPage });
      });
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get customConfig(): any {
    const config = WidgetContextDataShared.widgetContext.config;
    return config?.customConfig;
  }

  private initiateFlow(config: WorkflowContextData): void {
    let flow = this.workflowService.getFlowById(config.flowId);
    if (!flow) {
      flow = this.workflowService.getFirstFlow();
    }

    if (!flow.pages?.length) {
      const errorMessage = `The flow with id '${config.flowId}' doesn't have any pages`;
      this.onInvalidConfigDataError(errorMessage);
      return;
    }

    const currentFlowPath = flow.config.path;
    const currentPagPath = flow.pages[0].path;
    this.workflowService.setCurrentFlowAndPagePath(currentFlowPath, currentPagPath);
  }

  private isConfigValid(widgetContext: WidgetContextData): boolean {
    let errorMessage = '';

    if (!widgetContext?.config) {
      errorMessage = 'Context data has not been set';
      this.onInvalidConfigDataError(errorMessage);
      return;
    }

    return true;
  }

  private readonly onInvalidConfigDataError = (message) => {
    this.widgetStateService.updateState('error', 'Invalid Config Data. ->' + message);
  };
}
